module.exports = __webpack_public_path__ + "static/media/justin-marisa.7d2779c4.jpg";